import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class AuthService {
  static AUTH_ENDPOINT = `${BASE}/auth`;

  static async login(email, password) {
    return await request({
      url: `${this.AUTH_ENDPOINT}/login`,
      method: 'POST',
      body: { email, password },
      auth: false
    });
  }

  static async logout(email) {
    return await request({
      url: `${this.AUTH_ENDPOINT}/logout`,
      method: 'POST',
      body: { Email: email },
    });
  }

  static async getContactFromToken() {
    const data = await request({
      url: `${this.AUTH_ENDPOINT}/me`
    });
    if(data === 'unauthorized')
      throw new Error("Credenciales incorrectas");
    return data
  }

  static async getSession(id, token) {
    return await request({
      url: `${this.AUTH_ENDPOINT}/session/validate`,
      method: 'POST',
      headers: {'Accept': 'application/json'},
      body: { sessionId: id, resetToken: token },
      auth: false,
    });
  }
  
  static async sendUrl(sessionUrl) {
    return await request({
      url: `${this.AUTH_ENDPOINT}/send-url/`,
      method: 'POST',      
      body: sessionUrl,
      auth: false,
    });
  }

  static async recoverPassword(email) {
    try {
      return await this.sendUrl({ Email: email, Url: window.location.origin });
    } catch (e) {
      throw new Error(`No se pudo enviar el correo de recuperacion. ${e.message}`);
    }
  }

  static async updatePassword(authData) {
    return await request({
      url: `${this.AUTH_ENDPOINT}/change-password`,
      method: 'POST',
      body: authData,
      auth: false,
    });
  }
}

export default AuthService;
